import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    iconButton: {
      padding: '15px',
      height: '50px',
      display: 'flex',
      cursor: 'pointer',
    },
    listItem: {
      '&:not(:last-child)': {
        paddingBottom: theme.spacing(1),
      },
    },
    listItemTitle: {
      maxWidth: '198px',
      overflow: 'hidden',
      paddingRight: theme.spacing(1),
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    pulsePaper: {
      textAlign: 'center',
    },
    pulseButton: {
      padding: theme.spacing(0.5),
    },
    pulseAnswered: {
      padding: theme.spacing(1),
    },
    contentTitle: {
      backgroundColor: '#00ace6',
      color: 'white',
      fontSize: '14px',
      padding: theme.spacing(1),
    },
    content: {
      padding: theme.spacing(1),
      maxWidth: 400,
      maxHeight: 200,
      overflow: 'auto',
      marginBottom: '10px',
    },
  };
};
